export { default } from './TemperatureRange';
